<template>
  <div class="right-menu__passwordrecovery">
    <div class="right-menu__title">
      <h4>Восстановление пароля</h4>
    </div>
    <div class="t-form margin">
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.phone }">
          <input
            type="text"
            id="recovery-password-phone"
            @input="phoneFormat"
            :value="data.phone"
            maxlength="17"
            @click="() => clearError('phone')"
            @keydown.enter="submit"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.phone }"
            for="recovery-password-phone"
          >
            Номер телефона
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.phoneText }}</span>
        </div>
      </div>
    </div>
    <t-button type="small blue uppercase" :callback="submit"
      >Получить код</t-button
    >
  </div>
</template>

<script>
import { setPhoneFormat, resetPhoneFormat } from '@src/js/inputMasks.js';
import Button from '@components/ui/button.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  components: {
    't-button': Button,
  },
  data: function() {
    return {
      data: {
        phone: '',
      },
      errors: {
        phone: false,
        phoneText: '',
      },
      errorsText: {
        empty: 'Поле не должно быть пустым',
        shortPassword: 'Пароль должен быть 6 и более символов',
        mismatchPassword: 'Введеные пароли не совпадают',
        incorrectPassword: 'Неверный пароль',
        incorrectUser: 'Пользователя с таким телефоном не существует',
      },
    };
  },
  computed: {
    ...mapState('api', ['passwordRecover', 'sendCode', 'sendCodeRecover']),
  },
  methods: {
    ...mapActions('api', ['fetchRequest']),
    ...mapMutations('params', [
      'toogleCodeConfirm',
      'toogleSingup',
      'setToken',
      'setRecoveryPasswordPhone',
      'setConfirmCodeType',
      'togglePasswordrecovery',
    ]),
    phoneFormat: function({ target }) {
      this.data.phone = setPhoneFormat(target.value);
    },
    createPhone: function(value) {
      return resetPhoneFormat(value).slice(1);
    },
    validation: function() {
      let error = false;

      Object.keys(this.data).forEach((item) => {
        if (!this.data[item].trim()) {
          this.setErrors(item, 'empty');
          error = true;
        }
      });
    },
    form: function(data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => _form.append(item, data[item]));
      return _form;
    },
    setErrors: function(id, error) {
      this.errors[id] = true;
      this.errors[id + 'Text'] = this.errorsText[error];
    },
    setErrorsQuery: function(id, errorText) {
      this.errors[id] = true;
      this.errors[id + 'Text'] = errorText;
    },

    clearError: function(id) {
      this.errors[id] = false;
    },
    submit: function() {
      if (this.validation()) return;

      this.fetchRequest({
        url: this.sendCodeRecover,
        form: this.form({ phone: this.createPhone(this.data.phone) }),
        success: ({ body }) => {
          if (body.token) {
            this.setToken(body.token);
            this.setRecoveryPasswordPhone(this.createPhone(this.data.phone));
            this.setConfirmCodeType('PASWORD_RECOVERY');
            this.toogleCodeConfirm();
            this.togglePasswordrecovery();
          } else {
            try {
              console.log(body);
              this.setErrorsQuery('phone', body.error);

              //  Object.keys(body.errors).forEach((item) => {
              //    this.setErrorsQuery(item, body.errors[item][0]);
              //  });
            } catch (e) {
              console.log('code form error');
            }
          }
        },
        error: (e) => {
          console.log('error', e);
        },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.margin
  margin-bottom: 32px
</style>



// WEBPACK FOOTER //
// src/templates/components/right-menu/ui/passwordrecovery.vue